function initProductSwiper() {
  var productSwiper = new Swiper('.u-product-slider', {
    slidesPerView: 4,
    spaceBetween: 20,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      1200: { slidesPerView: 4 },
      992: { slidesPerView: 3 },
      768: { slidesPerView: 2 },
      250: { slidesPerView: 1 }
    }
  });
}

document.addEventListener('DOMContentLoaded', function() {
  function aggiornaData() {
    const doubleuspsElement = document.querySelector('.doubleusps');
    
    if (!doubleuspsElement) {
      console.error('Error: .doubleusps element not found');
      return;
    }
    const giorniDellaSettimana = doubleuspsElement.dataset.giorni.split(',');
    const mesi = doubleuspsElement.dataset.mesi.split(',');
    const nDays = window.nDays || 1;

    const ora = new Date();
    const futureDate = new Date(ora);
    futureDate.setDate(ora.getDate() + nDays); 

    const dataFormattata = `${giorniDellaSettimana[futureDate.getDay()]}, ${futureDate.getDate()} ${mesi[futureDate.getMonth()]}`;
    
    let cstmDate = document.getElementById('cstmdate');
    if (cstmDate) {
      cstmDate.innerText = dataFormattata;
    }

    const msFinoAllaMezzanotte = new Date(ora.setHours(24, 0, 0, 0)) - ora;
    setTimeout(() => {
      aggiornaData();
      setInterval(aggiornaData, 24 * 60 * 60 * 1000);
    }, msFinoAllaMezzanotte);
  }

  aggiornaData();
});

document.addEventListener('DOMContentLoaded', function () {
  // Select all uinventory blocks on the page
  document.querySelectorAll('.uinventory-box').forEach(function(box) {
    var min = parseInt(box.dataset.minnumber, 10);
    var max = parseInt(box.dataset.maxnumber, 10);
    var productId = box.dataset.productid;
    var storageKey = "uinventory_number_" + productId;

    // Check if number already exists in localStorage
    var savedNumber = localStorage.getItem(storageKey);

    if (savedNumber === null) {
      var randomNum = Math.floor(Math.random() * (max - min + 1)) + min;
      localStorage.setItem(storageKey, randomNum);
      savedNumber = randomNum;
    }

    // Output number
    var target = box.querySelector('.u-random-number');
    if (target) {
      target.textContent = savedNumber;
    }
  });
});
